import { CheckCircle2 } from 'lucide-react'
import type { FormEventHandler, ReactNode } from 'react'
import { Button } from './Button'

export function FormCard({
  title,
  submitLabel,
  onSubmit,
  children,
}: {
  title: string
  submitLabel: string
  onSubmit: FormEventHandler<HTMLFormElement>
  children: ReactNode
}) {
  return (
    <form className="rounded-xl border border-stone-200 bg-white p-5 shadow-sm" onSubmit={onSubmit}>
      <div className="mb-5">
        <h2 className="text-lg font-bold text-leaf-dark">{title}</h2>
      </div>
      {children}
      <div className="mt-6 flex justify-end border-t border-stone-100 pt-4">
        <Button icon={CheckCircle2} type="submit">
          {submitLabel}
        </Button>
      </div>
    </form>
  )
}
